// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__gUJDw","title":"Info_title__1XL1b","links":"Info_links__1TeWa","link":"Info_link__2pu7t","logo":"Info_logo__1e7ly"};